import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

import Section from 'components/common/Section';

import authApi from 'api/modules/authApi';
import paths from 'routes/paths';

const PasswordReset = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [email, setEmail] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();

    setIsLoading(true);

    try {
      await authApi.passwordReset({
        email,
      });

      toast.success(`A password reset link has been emailed to you!`);
      navigate(paths.confirmMail);
    } catch (error) {
      toast.error('Invalid email');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
          <Card>
            <Card.Body className="p-4 p-sm-5">
              <div className="text-center">
                <h5 className="mb-0"> Forgot your password?</h5>
                <small>Enter your email and we'll send you a reset link.</small>

                <Form className="mt-4" onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      placeholder="Email address"
                      value={email}
                      name="email"
                      onChange={({ target }) => setEmail(target.value)}
                      type="email"
                      required
                    />
                  </Form.Group>

                  <Form.Group>
                    <Button
                      className="w-100"
                      type="submit"
                      disabled={!email || isLoading}
                    >
                      Send reset link
                    </Button>
                  </Form.Group>
                </Form>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default PasswordReset;
